import { useState } from 'react'
import Offcanvas from 'react-bootstrap/Offcanvas'
import { Form } from 'react-bootstrap'
import { toast } from 'react-toastify'
import { UserInterface } from './Customer'
import WebService from '../../utility/WebService'
import { useForm } from 'react-hook-form'
import CustomButton from '../../components/CustomButton/CustomButton'
import { EyeFill, EyeSlashFill } from 'react-bootstrap-icons'

interface Props {
    isShow: boolean
    isClose: any
    user?: UserInterface | null
}

interface PasswordForm {
    currentPassword: string
    newPassword: string
    confirmPassword: string
}

const ChangePasswordBlade = ({ isShow, isClose, user }: Props) => {

    const {
        register,
        handleSubmit,
        watch,
        formState: { errors }
    } = useForm<PasswordForm>()

    const [showCurrentPassword, setShowCurrentPassword] = useState(false)
    const [showNewPassword, setShowNewPassword] = useState(false)
    const [showConfirmPassword, setShowConfirmPassword] = useState(false)
    const [isLoading, setIsLoading] = useState(false)

    const onSubmit = (data: PasswordForm) => {
        const requestBody = {
            id: user?._id,
            currentPassword: data.currentPassword,
            password: data.newPassword,
            confirmPassword: data.confirmPassword
        }

        setIsLoading(true)
        WebService.postAPI({
            action: 'users/change-user-password',
            body: requestBody,
        })
            .then(() => {
                toast.success('Password changed successfully.')
                setIsLoading(false)
                isClose(true)
            })
            .catch((err) => {
                toast.error(err?.response?.data?.message || 'Failed to change password.')
                setIsLoading(false)
            })
    }

    return (
        <Offcanvas show={isShow} onHide={isClose} placement="end" className="offcanvas-small">
            <Offcanvas.Header closeButton>
                <Offcanvas.Title>Change Password</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body className="border-bottom px-0 information-main-view">
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="px-3 form-style">

                        {/* Current Password */}
                        {/* <div className="form-group mb-2">
                            <Form.Label className="label">
                                Current Password <span className="text-danger">*</span>
                            </Form.Label>
                            <div className="input-group">
                                <input
                                    type={showCurrentPassword ? 'text' : 'password'}
                                    className="form-control ps-2 pe-2"
                                    style={{
                                        height: "36px",
                                        boxShadow: "none",
                                        outline: "none",
                                        marginBottom: "unset",
                                        fontSize: "1rem"
                                    }}
                                    placeholder="Current Password"
                                    {...register('currentPassword', { required: 'Enter current password' })}
                                />
                                <span
                                    className="input-group-text cursor-pointer"
                                    onClick={() => setShowCurrentPassword(prev => !prev)}
                                >
                                    {showCurrentPassword ? <EyeSlashFill size={16} /> : <EyeFill size={16} />}
                                </span>
                            </div>
                            {errors.currentPassword && <div className="error-message">{errors.currentPassword.message}</div>}
                        </div> */}

                        {/* New Password */}
                        <div className="form-group mb-2">
                            <Form.Label className="label">
                                New Password <span className="text-danger">*</span>
                            </Form.Label>
                            <div className="input-group">
                                <input
                                    type={showNewPassword ? 'text' : 'password'}
                                    className="form-control ps-2 pe-2"
                                    style={{
                                        height: "36px",
                                        boxShadow: "none",
                                        outline: "none",
                                        marginBottom: "unset",
                                        fontSize: "1rem"
                                    }}
                                    placeholder="New Password"
                                    {...register('newPassword', {
                                        required: 'Enter new password',
                                        // minLength: { value: 8, message: 'Minimum 8 characters' },
                                        pattern: {
                                            value: /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])/,
                                            message: 'Must contain uppercase, number & special char'
                                        }
                                    })}
                                />
                                <span
                                    className="input-group-text cursor-pointer"
                                    onClick={() => setShowNewPassword(prev => !prev)}
                                >
                                    {showNewPassword ? <EyeSlashFill size={16} /> : <EyeFill size={16} />}
                                </span>
                            </div>
                            {errors.newPassword && <div className="error-message">{errors.newPassword.message}</div>}
                        </div>

                        {/* Confirm Password */}
                        <div className="form-group mb-2">
                            <Form.Label className="label">
                                Confirm Password <span className="text-danger">*</span>
                            </Form.Label>
                            <div className="input-group">
                                <input
                                    type={showConfirmPassword ? 'text' : 'password'}
                                    className="form-control ps-2 pe-2"
                                    style={{
                                        height: "36px",
                                        boxShadow: "none",
                                        outline: "none",
                                        marginBottom: "unset",
                                        fontSize: "1rem"
                                    }}
                                    placeholder="Confirm Password"
                                    {...register('confirmPassword', {
                                        required: 'Enter confirm password',
                                        validate: (val) => val === watch('newPassword') || 'Passwords do not match'
                                    })}
                                />
                                <span
                                    className="input-group-text cursor-pointer"
                                    onClick={() => setShowConfirmPassword(prev => !prev)}
                                >
                                    {showConfirmPassword ? <EyeSlashFill size={16} /> : <EyeFill size={16} />}
                                </span>
                            </div>
                            {errors.confirmPassword && <div className="error-message">{errors.confirmPassword.message}</div>}
                        </div>
                    </div>

                    <div className="d-flex justify-content-center gap-3 p-3">
                        <button
                            className="btn btn-outline-secondary flex-fill"
                            type="button"
                            onClick={isClose}
                        >
                            Cancel
                        </button>
                        <CustomButton
                            isLoading={isLoading}
                            label="Save"
                            className="flex-fill"
                            type="submit"
                        />
                    </div>
                </form>
            </Offcanvas.Body>
        </Offcanvas>
    )
}

export default ChangePasswordBlade
